import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models (j218/models/j218.go)
// ============================================================

export interface FJ730 {
  fj730_01: string;          // 分析單號 (PK)
  fj730_11: string;          // 開發單號
  fj730_12: string | null;   // 分析日期 (ISO date)
  fj730_13: string;          // 產品用途
  fj730_14: string;          // 廠商收件單號
  fj730_15: number;          // 收件單項次
  fj730_161: string;         // 產品代號前段
  fj730_162: string;         // 產品代號後段
  fj730_17: string;          // 產品規格/備忘
  fj730_171: string;
  fj730_172: string;
  fj730_18: number;
  fj730_181: number;
  fj730_182: string;
  fj730_19: string;
  fj730_191: string;
  // 經紗組1
  fj730_201: number;
  fj730_202: string;
  fj730_203: string;
  fj730_204: number;
  fj730_205: number;
  fj730_206: number;
  fj730_207: string;
  fj730_208: string;
  // 經紗組2
  fj730_211: number;
  fj730_212: string;
  fj730_213: string;
  fj730_214: number;
  fj730_215: number;
  fj730_216: number;
  fj730_217: string;
  fj730_218: string;
  // 緯紗組
  fj730_221: number;
  fj730_222: string;
  fj730_223: string;
  fj730_224: number;
  fj730_225: number;
  fj730_226: number;
  fj730_227: string;
  fj730_228: string;
  // 組織/密度
  fj730_23: string;
  fj730_241: number;
  fj730_242: number;
  fj730_251: number;
  fj730_252: number;
  fj730_253: number;
  fj730_261: number;
  fj730_262: number;
  fj730_27: string;
  fj730_281: number;
  fj730_282: string;
  fj730_29: string;
  fj730_291: string;
  // 染整組 1-3
  fj730_301: string; fj730_302: number; fj730_303: number; fj730_304: string; fj730_305: number; fj730_306: string; fj730_307: string;
  fj730_311: string; fj730_312: number; fj730_313: number; fj730_314: string; fj730_315: number; fj730_316: string; fj730_317: string;
  fj730_321: string; fj730_322: number; fj730_323: number; fj730_324: string; fj730_325: number; fj730_326: string; fj730_327: string;
  // 成品
  fj730_41: string; fj730_42: number; fj730_43: string; fj730_44: string; fj730_45: number;
  // 成品/物化性
  fj730_51: string;
  fj730_521: number; fj730_522: number;
  fj730_531: number; fj730_532: number; fj730_533: number;
  fj730_541: number; fj730_542: number;
  fj730_55: string; fj730_561: number; fj730_562: string;
  fj730_57: string; fj730_571: string;
  // 物化性報告
  fj730_61: string; fj730_611: string; fj730_612: string;
  // 管理欄位
  fj730_62: string;
  fj730_63: string;
  fj730_64: string;
  fj730_65: string;
  fj730_701: string; fj730_702: string; fj730_703: string;
  fj730_704: string; fj730_705: string; fj730_706: string;
  fj730_76: string;
  fj730_77: string | null;
  fj730_78: string | null;
  fj730_79: number;
  fj730_80: string;
  fj730_91: string;
  fj730_92: string | null;
  fj730_93: string;

  details?: FJ731[];
}

export interface FJ731 {
  fj731_01: string;   // 分析單號 FK
  fj731_02: number;   // 項次
  fj731_11: string;   // 洗標代碼
  fj731_12: string;   // 洗標說明
}

export interface J218ListResponse {
  data: FJ730[];
  total: number;
  page: number;
  size: number;
}

export interface J218CreateRequest {
  master: Partial<FJ730>;
  details: Partial<FJ731>[];
}

export const j218Api = {
  async list(page = 1, size = 20): Promise<J218ListResponse> {
    const res = await apiClient.get('/api/j218', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FJ730> {
    const res = await apiClient.get(`/api/j218/${encodeURIComponent(id)}`);
    return res.data;
  },

  async loadSourceDraft(id: string): Promise<FJ730> {
    const res = await apiClient.get(`/api/j218/source/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: J218CreateRequest): Promise<FJ730> {
    const res = await apiClient.post('/api/j218', data);
    return res.data;
  },

  async update(id: string, data: J218CreateRequest): Promise<FJ730> {
    const res = await apiClient.put(`/api/j218/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/j218/${encodeURIComponent(id)}`);
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/j218/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
